import { render, staticRenderFns } from "./CardInfo.vue?vue&type=template&id=04b9a40d&scoped=true"
import script from "./CardInfo.vue?vue&type=script&lang=js"
export * from "./CardInfo.vue?vue&type=script&lang=js"
import style0 from "./CardInfo.vue?vue&type=style&index=0&id=04b9a40d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b9a40d",
  null
  
)

export default component.exports